/**
 * FinancialsStandardPrint — rapport « États financiers » : UN seul rapport print
 * qui sort, chacun sur sa page, la suite complète du hub :
 *   Synthèse · Compte de résultat · Bilan · Tableau de flux · Ajustements (annexe).
 * Chaque sous-rapport rend sa propre section A4 ; on ne signale `onDataReady` au
 * host qu'UNE fois, lorsque les 5 sous-rapports ont chargé (sinon le compteur de
 * pages prêtes du host se déclencherait trop tôt).
 */
import React, { useRef } from 'react';
import FinancialsSynthesisPrint from './FinancialsSynthesisPrint';
import ProfitLossPrint from './ProfitLossPrint';
import BalanceSheetPrint from './BalanceSheetPrint';
import CashFlowPrint from './CashFlowPrint';
import AdjustmentsPrint from './AdjustmentsPrint';

const SUB_COUNT = 5;

export default function FinancialsStandardPrint({ activeTenant, year, editedAt, onDataReady, cutoff = null }) {
  const done = useRef(0);
  const fired = useRef(false);
  const childReady = () => {
    done.current += 1;
    if (done.current >= SUB_COUNT && !fired.current) {
      fired.current = true;
      if (onDataReady) onDataReady('financials-standard');
    }
  };
  const common = { activeTenant, year, editedAt, cutoff, onDataReady: childReady };

  return (
    <>
      <FinancialsSynthesisPrint {...common} />
      <ProfitLossPrint {...common} />
      <BalanceSheetPrint {...common} />
      <CashFlowPrint {...common} />
      <AdjustmentsPrint {...common} />
    </>
  );
}
